// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1b7GA","unreadBadge":"styles_unreadBadge__10MhH","modalContent":"styles_modalContent__1oN3r","modal":"styles_modal__3GvUR"};